import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useTheme, withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import FontAwesome from 'Components/UI/FontAwesome/FontAwesome';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import MuiListItem from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItem';
import { iconMapper } from 'Components/Files/utils';
import { ListItemSecondaryAction } from '@material-ui/core';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';

const styles = () => ({
  root: {},
  secondaryAction: {
    pointerEvents: 'none',
  },
});

const ListItem = ({
  className,
  classes,
  onClick,
  resource,
  ...rest
}) => {
  const theme = useTheme();
  const fileName = resource.attr('name');
  const {
    icon,
    color,
  } = iconMapper(resource.attr('name').split('.').pop().toLowerCase(), theme);

  return (
    <MuiListItem
      button
      className={classNames(classes.root, className)}
      onClick={onClick}
      {...rest}
    >
      <ListItemAvatar>
        <FontAwesome
          icon={icon}
          style={{ color }}
          className="fa-2x"
        />
      </ListItemAvatar>
      <ListItemText
        primary={fileName}
        secondary={`Uploaded ${moment(resource.attr('createdAt')).format('llll')}`}
        primaryTypographyProps={{
          color: 'primary',
          variant: 'h6',
          noWrap: true,
        }}
        secondaryTypographyProps={{
          variant: 'body1',
          noWrap: true,
        }}
      />
      <ListItemSecondaryAction
        className={classes.secondaryAction}
      >
        <IconButton
          edge="end"
          className={classes.icon}
          aria-label="View File"
          title="View File"
          color="primary"
          size="large"
          icon={ChevronRightIcon}
        />
      </ListItemSecondaryAction>
    </MuiListItem>
  );
};

ListItem.defaultProps = {
  className: '',
};

ListItem.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  resource: PropTypes.object.isRequired,
};

export default withStyles(styles)(ListItem);
